<!-- vista principal -->
<dram-hero></dram-hero>
<credit-simulator></credit-simulator>
<reactive-text></reactive-text>
<process-animations-banner></process-animations-banner>
<dram-slides></dram-slides>
<grow-allies-phrase></grow-allies-phrase>
<!-- <last-reels-ig></last-reels-ig> -->
<grow-today-phrase></grow-today-phrase>
<dram-capital-banner></dram-capital-banner>
<dram-footer></dram-footer>
